import { render, staticRenderFns } from "./BuildingShowEnabledOptionsTab.vue?vue&type=template&id=0ba6b3c3"
import script from "./BuildingShowEnabledOptionsTab.vue?vue&type=script&lang=ts"
export * from "./BuildingShowEnabledOptionsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports